<template>
  <div id="se-tab-lcl-container" class="app-main-content">
    <cargo-up-down-resize
      class="main-content"
      :up-style="{ display: 'flex', flexDirection: 'column', paddingBottom: '5px' }"
      :down-style="{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }"
      style="height: 100%"
    >

      <template slot="up">
        <div v-show="isEdit" class="section">
          <div>
            <el-button no="1" type="primary" @click="pm.addSlaveHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
            <el-button no="2" type="danger" @click="pm.removeSlaveHandler()">{{ $t('SeaExport.RemoveTickets')
            }}</el-button>
          </div>
        </div>
        <div class="section" style="flex: 1">
          <cargo-ag-grid
            no="3"
            config-module="130116"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="lclSlaves"
            style="width:100%;flex:1"
            @gridReady="params => gridApi = params.api"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <!--拆分主票-->
            <!-- <el-button
              v-show="showSplitButton && viewSource != 'salesDetail'"
              no="4"
              type="primary"
              @click="pm.splitClickEventHandler()"
            >{{ $t('SeaExport.SplitHbl') }}</el-button>
            <el-button v-show="openXhqCustomsAll" no="xhqShowSendContainerHandler" type="primary" @click="xhqShowSendContainerHandler">{{ $t('CargoMsg.SendContainer') }}</el-button>
            <el-button v-show="openXhqCustomsAll" no="xhqCustomsUnFrozenHandler" type="primary" @click="toXhqCustomsUnFrozenHandler">{{ $t('CargoMsg.CustomsUnFrozen') }}</el-button> -->
            <el-button v-show="isEdit" no="5" type="primary" @click="changeSealHandler">{{
              $t('SeaExport.SealNoChangeAdfterInspection') }}</el-button>
            <el-button
              v-show="isEdit"
              no="6"
              type="info"
              plain
              style="color:green"
              @click="pm.addToContainerHandler()"
            >↓</el-button>
            <el-button
              v-show="isEdit"
              no="7"
              type="info"
              plain
              style="color:red"
              @click="p=>{pm.removeToContainerHandler();changeLclSlaves()}"
            >↑</el-button>
            <!-- <el-badge v-show="isEdit" no="8" :is-dot="harbourCheckRead" class="item">
              <el-button v-show="isEdit" no="9" class="share-button" type="primary" @click="harbourCompare">{{
                $t('SeaExport.DataComparison') }}</el-button>
            </el-badge>
            <el-button
              v-show="isEdit"
              no="10"
              type="primary"
              style="margin-left: 5px;"
              size="mini"
              @click="harbourSync"
            >{{ $t('SeaExport.SynchronizePortData') }}</el-button> -->
          </div>
          <!-- <div style="display: flex; align-items: center; gap: 16px;margin-left: 200px;">
            <el-button v-if="jingyuWarehouse" no="ReleaseJY" type="primary" @click="toReleaseJY">{{ $t('SeaExport.ReleaseJY') }}</el-button>
            <el-button v-if="jingyuWarehouse" no="TakeContainerJY" type="primary" @click="toTakeContainerJY">{{ $t('SeaExport.TakeContainerJY') }}</el-button>
            <el-button v-if="jingyuWarehouse" no="ContainerPreloadJY" type="primary" @click="toContainerPreloadJY">{{ $t('SeaExport.ContainerPreloadJY') }}</el-button>
            <el-button v-if="toExoSystemJYD && job.masterFlag" :disabled="!(!jydEnable && !isEdit && job.jobState === 0)" no="canPushPreConfiguration" type="primary" @click="toCanPushPreConfiguration">{{ $t('SystemMaintenance.canPushPreConfiguration') }}</el-button>
          </div> -->
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalQuantity" no="11" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalWeight')" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalWeight" no="12" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalCubage')" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalCubage" no="13" style="width:100px" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>

      <template slot="down">
        <cargo-left-right-resize
          :left-style="{ display: 'flex', flexDirection: 'column', width: '20%' }"
          :right-style="{ display: 'flex', flexDirection: 'column', width: '80%' }"
          style="height: 100%;min-height: 300px"
        >
          <template slot="left">
            <div class="section" style="flex: 1">
              <cargo-ag-grid
                no="14"
                config-module="130117"
                :grid-options="left.gridOptions"
                :grid-params.sync="left.gridParams"
                :column-defs="containerColumnDefs"
                :row-data="containers"
                style="height:100%"
                @gridReady="params => left.gridApi = params.api"
              />
            </div>
          </template>
          <template slot="right">
            <div class="section" style="flex: 1;">
              <cargo-ag-grid
                no="15"
                config-module="130118"
                :grid-options="right.gridOptions"
                :grid-params.sync="right.gridParams"
                :column-defs="usageColumnDefs"
                :row-data="selectedContainer.containerUsage"
                style="flex-grow:1"
                @gridReady="params => right.gridApi = params.api"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                <span>{{ usagesTotalDesc.txtNum }}</span>
              </div>
              <div v-if="jingyuWarehouse" class="lcl-dynamic-div">
                <span v-show="jingyuWarehouse && !isEdit" class="lcl-dynamic-span" @click="showLclDynamicList"> {{ $t('SeaExport.LclDynamic') }} <i :class="jyLclDynamicDialog.visible?'el-icon-caret-bottom':'el-icon-caret-top'" /> </span>
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalQuantity" no="16" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalWeight" no="17" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalCubage" no="18" style="width:100px" />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainer"
      @sealCloseHandler="sealCloseHandler"
    />
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="job"
      @callback="rows => { pm.slaveAddedHandler(rows) }"
    />
    <!-- 港区数据对比弹窗 -->
    <lcl-compare-harbour-dialog
      :visible.sync="harbourDialog"
      :data-source="containers"
      :harbour-source="sourceList"
      :job="job"
      :lcl-slave-so-no="lclSlaveSoNo"
      :hc-flag="hcFlag"
      :hq-flag="hqFlag"
      :container-height-flag="containerHeightFlag"
      :h-q-h-c-flag="HQHCFlag"
      @addContainer="handleAddContainer"
    />
    <!-- 箱子信息对比提示弹窗 -->
    <box-Information-Verification
      :dialog-visible.sync="portareaDialogVisible"
      :content-show="contentShow"
      :container="container"
    />
    <el-dialog :title="$t('FileHistory.Tips')" :visible.sync="dialogVisible" width="30%">
      <div class="portData-check">
        <i class="el-icon-error" /><strong>S/O NO{{ $t('SeaExport.ItPortDataAndVerified') }}</strong>
        <p>{{ $t('SeaExport.TheNotContainTheData') }}S/O NO.</p>
        <p v-for="item in checkSoNo" :key="item">{{ item }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="19" @click="dialogVisible = false">{{ $t('Message.GotIt') }}</el-button>
      </span>
    </el-dialog>
    <!-- 发送装箱信息到信号旗 -->
    <xhq-send-container-dialog
      :dialog-visible.sync="xhqSendContainerDialog.visible"
      :job="job"
      :container-usage="xhqSendContainerDialog.containerUsage"
      :selected-container="selectedContainer"
    />
    <!-- 精谕放单弹窗 -->
    <jy-release-dialog :job="job" :containers="containers" :visible.sync="jyReleaseDialog.visible" />
    <!-- 精谕提箱弹窗 -->
    <jy-take-container-dialog :job="job" :containers="jyTakeContainerDialog.containers" :visible.sync="jyTakeContainerDialog.visible" />
    <!-- 精谕装箱弹窗 -->
    <jy-container-preload-dialog :job="job" :containers="jyContainerPreloadDialog.containers" :visible.sync="jyContainerPreloadDialog.visible" />
    <!-- 精谕拼箱动态弹窗 -->
    <jy-lcl-dynamic-dialog :job-uuid="job.uuid" :visible.sync="jyLclDynamicDialog.visible" />
  </div>
</template>

<script>
import tabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'

export default {
  name: 'SeTabLclContainer',
  extends: tabLclContainer,
  props: {
    containerConfig: { type: Object, default: () => { } }
  }
}
</script>

<style lang='scss'>
.data-red {
  color: #FF0000;
}
.data-blue {
  color: #0000ff;
}
#se-tab-lcl-container {
  .data-red {
    input.el-input__inner {
      color: #FF0000;
    }
  }
  .data-blue {
    input.el-input__inner {
      color: #0000ff;
    }
  }
  .el-dialog__wrapper {
    pointer-events: none;
  }
  .el-dialog {
    pointer-events: auto;
  }
}
</style>

<style lang="scss" scoped>
.portData-service {
  padding-top: 10px;
  &>i {
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }
  &>span {
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }
  &>p {
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}
.portData-check {
  padding-top: 10px;
  &>i {
    margin-right: 5px;
    color: red;
    font-size: 30px;
    vertical-align: middle;
  }
  strong {
    margin-left: 5px;
    font-size: 14px;
  }
  p {
    margin: 0 0 5px 0;
    padding-left: 40px;
  }
}
.lcl-dynamic-div {
  float:right;
}
.lcl-dynamic-span {
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  color:deepskyblue;
  cursor:pointer;
  padding-left: 5px;
}
</style>
